import { create } from "zustand";

export const useLoginStore = create((set) => ({
  isLogin: false,
  OnClose: () => set(() => ({ isLogin: false })),
  SetIsLogin: (inputMode) => set(() => ({ isLogin: inputMode })),
}));
